
/*
 * Implementation of a d3-curve that draws a linear line using
 * bezier curve path commands, rather than lineTo's
 */
class LinearCurve {

  constructor (context) {
    this._context = context
  }

  areaStart () {
    this._line = 0
  }

  areaEnd () {
    this._line = NaN
  }

  lineStart () {
    this._point = 0
    this._previous = null
  }

  lineEnd () {
    if (this._line || (this._line !== 0 && this._point === 1)) {
      this._context.closePath()
    }
    this._line = 1 - this._line
  }

  point (x, y) {
    x = +x
    y = +y

    switch (this._point) {
      case 0:
        this._point = 1
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y)
        this._previous = {x, y}

        break
      case 1:
        this._point = 2 // proceed
      default:
        this._context.bezierCurveTo(this._previous.x, this._previous.y, x, y, x, y)
        this._previous = {x, y}
        break
    }
  }

}

export default LinearCurve
